import { useState } from "react";
import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import ReactJsonPretty from "react-json-pretty";
import { ArrowsPointingOutIcon } from "@heroicons/react/24/outline";

export default PreviewJson;

function PreviewJson(props) {
  const { data, title } = props;
  const [expand, setExpand] = useState(false);

  return (
    <>
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <p className="text-sm">{title}</p>
          <Button
            plain
            onClick={() => setExpand(true)}
          >
            <ArrowsPointingOutIcon />
          </Button>
        </div>
        <pre className="p-3 bg-zinc-50 rounded-lg border text-xs text-zinc-600 max-h-48 overflow-auto whitespace-pre-wrap">
          <ReactJsonPretty
            data={data}
            theme={{
              main: "line-height:20px",
              string: "color:oklch(48.8% 0.243 264.376)",
              key: "color:oklch(70.5% 0.015 286.067)",
            }}
          />
        </pre>
      </div>
      {expand && (
        <Dialog
          size="5xl"
          open={expand}
          onClose={() => setExpand(false)}
        >
          <DialogTitle>{title}</DialogTitle>
          <DialogBody>
            <div className="w-full flex-1 max-h-[80dvh] overflow-auto p-4 border rounded-lg">
              <ReactJsonPretty
                json={data}
                theme={{
                  main: "line-height:20px;font-size:14px",
                  string: "color:oklch(48.8% 0.243 264.376)",
                  key: "color:oklch(70.5% 0.015 286.067)",
                }}
              />
            </div>
          </DialogBody>
          <DialogActions>
            <Button
              outline
              onClick={() => setExpand(false)}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
